(function (global) {
    define('LNRS/Components/Content/Collections/StickyAnchorMenu',["jquery", "vue", "eventManager", "scrollspy"], function ($, Vue, eventManager) {
        var component = {
            mounted: function () {
                $("body").scrollspy({ target: "#" + this.$el.id, offset: this.offset });

                this.$bootstrapSelect = $("#bss-" + this.$el.id, this.$el).first();
                this.$dropDownList = $("#ddl-" + this.$el.id, this.$el).first();
                this.$navUl = $("#nav-" + this.$el.id, this.$el).first();

                var selectedText = $(".nav li.active > a", this.$el).text();
                this.selectedOptionText = selectedText ? selectedText : "Please select";

                this.applyViewChanges();

                $("a[href*=#]:not([href=#]):not([href^=#collapse-])").click(function (e) {
                    if (window.location.pathname.replace(/^\//, "") === e.currentTarget.pathname.replace(/^\//, "") || window.location.hostname === e.currentTarget.pathname.hostname) {
                        var target = $(e.currentTarget.hash);
                        target = target.length ? target : $("[name=" + e.currentTarget.hash.slice(1) + "]");
                        if (target.length) {
                            $("body,html").animate({ scrollTop: target.offset().top }, this.animationSpeed);
                            if (this.isMobileView) {
                                this.$bootstrapSelect.removeClass("open");
                            }
                            return false;
                        }
                    }
                }.bind(this));

                $("#" + this.$el.id).on("activate.bs.scrollspy", function () {
                    this.selectedOptionText = $(".nav li.active > a", this.$el).text();
                }.bind(this));

                $(window).resize(function () {
                    this.applyViewChanges();
                }.bind(this));

                $(this.$el).affix({
                    offset: {
                        top: this.$el.dataset.offsetTop,
                        bottom: this.$el.dataset.offsetBottom
                    }
                });

                eventManager.subscribe("CookieDisclaimerAlertIsShown", function () {
                    if (this.$el.classList.contains("affix")) {
                        $(this.$el).css("top", this.getHeaderHeight());
                    }
                    $(this.$el).affix("checkPosition");
                }.bind(this));

                eventManager.subscribe("CookieDisclaimerAlertIsClosed", function () {
                    if (this.$el.classList.contains("affix")) {
                        $(this.$el).css("top", this.getHeaderHeight());
                    }
                    $(this.$el).affix("checkPosition");
                }.bind(this));

                $(this.$el).on('affixed-top.bs.affix', function () {
                    $(this.$el).removeAttr("style");
                    setTimeout(function () {
                        $(".page-wrapper").css("padding-top", this.getHeaderHeight());
                    }.bind(this), 200);
                }.bind(this));

                $(this.$el).on('affix.bs.affix', function () {
                    setTimeout(function() {
                        $(this.$el).css("top", this.getHeaderHeight());
                    }.bind(this), 100);
                }.bind(this));

                $(this.$el).attr("data-ux-state", "loaded").removeAttr("data-ux-args");
                eventManager.trigger("StickyAchorMenuLoaded");
            },
            methods: {
                getIsMobileView: function() {
                    return window.innerWidth < 992;
                },
                applyViewChanges: function () {
                    this.isMobileView = this.getIsMobileView();
                    if (this.isMobileView && !this.$navUl.parent().is(this.$dropDownList)) {
                        this.$navUl.appendTo(this.$dropDownList);

                    } else if (!this.isMobileView && this.$navUl.parent().is(this.$dropDownList)) {
                        this.$navUl.appendTo("#" + this.$el.id);
                    }
                },
                getHeaderHeight: function () {
                    var $pageWrapper = $(".page-wrapper");
                    if (!$pageWrapper.hasClass("preview")) {
                        return parseInt($("header.score-header").height(), 10) + "px";
                    } else {
                        return parseInt($("#scWebEditRibbon").height(), 10) + "px";
                    }
                }
            }
        };

        return function initStickyAnchorMenu(args) {
            component.el = args.scope;
            component.data = {
                offset: args.Offset,
                animationSpeed: args.AnimationSpeed,
                selectedOptionText: null,
                isMobileView: false,
                $bootstrapSelect: null,
                $dropDownList: null,
                $navUl: null
            };
            return args.IsPageEditorEditing === true ? null : new Vue(component);
        };
    });
})(this);
